<template>
  <div class="poster">
    <!-- 企业码 -->
    <div v-if="type == 'enterprisePoster' || type == 'enterpriseMeeting' || type =='enterpriseExhibition'">
      <div v-if="type == 'enterpriseMeeting' || type == 'enterpriseExhibition'" class="enterMeetOrExhibition">
        <div class="section_3 flex-col">
          <img class="image_6" referrerpolicy="no-referrer" :src="pageInfo.coverUrl" />
          <img class="image_3" referrerpolicy="no-referrer" :src="enterpriseLogo" />
          <div class="text-group_3 flex-col justify-between">
            <span class="text_3">{{pageInfo.enterpriseName}}</span>
            <span class="text_4">作为{{identity}}邀请您参加{{type == 'enterpriseMeeting' ?'会议':'展会'}}～</span>
          </div>
          <div class="group_4 flex-row justify-between">
            <div class="box_6 flex-col justify-between">
              <div class="image-wrapper_1 flex-col">
                <img class="label_6" referrerpolicy="no-referrer" src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG00cc78f5a8517e90de5a0d8d16fd8f6c.png" />
              </div>
              <div class="image-wrapper_2 flex-col">
                <img class="label_7" referrerpolicy="no-referrer" src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGe63d9882212f5dafaec3b5f01a201194.png" />
              </div>
            </div>
            <div class="text-group_4 flex-col justify-between">
              <span class="text_5">{{pageInfo.startTimeStr}}-{{pageInfo.endTimeStr}}</span>
              <span class="text_6">{{pageInfo.address}}</span>
            </div>
          </div>
          <div class="group_5 flex-row justify-between">
            <span class="text_7">{{pageInfo.introduction}}</span>
            <div class="box_7 flex-col justify-between">
              <img class="image_4" referrerpolicy="no-referrer" :src="pageInfo.qrCodeUrl" />
              <span class="text_8">长按识别展会码</span>
            </div>
          </div>
        </div>

      </div>
      <div v-else class=" enterPrise group_5 flex-col">
        <div class="image-text_3 flex-row justify-between">
          <img class="image_4" referrerpolicy="no-referrer" :src="avatar" />
          <div class="text-group_5 flex-col justify-between">
            <span class="text_5">{{userName}}</span>
            <span class="text_6">我在这里发现了一家宝藏公司，你也来看看吧～</span>
          </div>
        </div>
        <img class="image_3" referrerpolicy="no-referrer" :src="pageInfo.shareCover" />
        <div class="text-group_4 flex-col">
          <span class="text_3 text-ellipsis-2">{{pageInfo.enterpriseName}}</span>
          <span class="text_4 text-ellipsis-1">{{pageInfo.introduction}}</span>
        </div>
        <!-- <div class="group_6 flex-col"></div> -->

        <!-- <div class="group_7 flex-col"></div> -->
        <div class="section_1 flex-row">
          <!-- <div class="block_2 flex-col" v-if=" meetingCode != 'undefined'">
          <img :src="meetingLogo" alt="">
        </div>
        <span cla    ss="text_7" v-if=" meetingCode != 'undefined'">{{ meetingName }}</span> -->
          <div class="image-text_4 flex-col justify-between">
            <img class="image_5" referrerpolicy="no-referrer" :src="enterPriseqrcode" />
            <span class="text-group_3">长按识别二维码</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 会议海报/展会海报 -->
    <div class="meet" v-else>
      <div class="block_1 flex-col">

        <div class="image-text_3 flex-row justify-between" style="align-items:center;">
          <img class="image_4" referrerpolicy="no-referrer" :src="enterpriseCode ? pageInfo.enterpriseLogo : avatar" />
          <div class="text-group_3 flex-col justify-between">
            <span class="text_6">{{enterpriseCode ? pageInfo.enterpriseName : userName}}</span>
            <span class="text_7">{{type == 'userMeeting'?'邀请您参加':'邀请您参加'}}</span>
          </div>
        </div>

        <img class="image_3" referrerpolicy="no-referrer" :src="pageInfo.coverUrl" />
        <span class="text_3">{{pageInfo.meetingName}}</span>
        <div class="box_8 flex-row justify-between">
          <img class="label_6" referrerpolicy="no-referrer" src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG8df473ce4766a21a7c0cd7e629e61a12.png" />
          <span class="text_4"> {{ pageInfo.startTime | forMatterTime }} - {{ pageInfo.endTime | forMatterTime }}</span>
        </div>
        <div class="box_9 flex-row justify-between">
          <div class="image-wrapper_2 flex-col">
            <img class="label_7" referrerpolicy="no-referrer" src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNGd3d5bebb8577e744081931fc33a8ecd9.png" />
          </div>
          <span class="text_5"> {{ pageInfo.address ? pageInfo.address + '-' : '' }}{{ pageInfo.meetingRoom || '' }}</span>
        </div>
        <div class="image-text_4 flex-col justify-between" style="align-items:center;">
          <img class="image_5" referrerpolicy="no-referrer" :src="pageInfo.qrCodeUrl" />
          <span class="text-group_2">长按识别二维码</span>
        </div>
      </div>
    </div>
    <div id='DONE' v-if="complete"></div>
  </div>
</template>

<script>
import { GetQueryString, loadImageEnd } from '@/utils/utils'
import { getEnterPriseQrcode, getEnterpriseHomePage, getMeetingPoster, exhibitionPoster, handleEnterpriseCodeByScene } from '@/api/posterApi'
import wmtDate from '@/utils/date.js'
export default {
  name: 'enterpriseposter',

  data() {
    return {
      complete: false,
      headers: {},
      meetingCode: '',
      pageInfo: {
        logo: '',
      },
      userName: '',
      avatar: '',
      enterPriseqrcode: '',
      enterpriseLogo: '',
      enterpriseName: '',
    }
  },

  filters: {
    forMatterTime(val) {
      return wmtDate.fromatDate('yyyy/MM/dd hh:mm', new Date(val))
    },
  },

  async created() {
    this.type = decodeURIComponent(GetQueryString('type'))
    this.meetingCode = decodeURIComponent(GetQueryString('meetingCode'))
    this.token = decodeURIComponent(GetQueryString('token'))
    this.userName = decodeURIComponent(GetQueryString('userName'))
    this.avatar = decodeURIComponent(GetQueryString('avatar'))
    this.appKey = decodeURIComponent(GetQueryString('appKey'))
    this.eventKey = decodeURIComponent(GetQueryString('eventKey'))
    this.enterpriseCode = decodeURIComponent(GetQueryString('enterpriseCode'))
    this.meetingName = decodeURIComponent(GetQueryString('meetingName'))
    this.meetingLogo = decodeURIComponent(GetQueryString('meetingLogo'))
    this.identity = decodeURIComponent(GetQueryString('identity'))
    console.log(this.meetingCode, this.type)
    var headerClientInfo = { language: 'CN', eventKey: this.eventKey, appKey: this.appKey, enterpriseCode: this.enterpriseCode, userIdentity: this.enterpriseCode ? 'ENTERPRISES' : '' }
    this.headers = {
      'x-call-client-info': JSON.stringify(headerClientInfo),
      Authorization: this.token,
    }
    if (this.enterpriseCode) {
      await this.getHomePage()
    }
    this.handelMethod()
  },

  methods: {
    handelMethod() {
      console.log(this.type)
      switch (this.type) {
        case 'enterprisePoster':
          this.handleEnterpriseCodeFunc()
          break
        case 'enterpriseMeeting':
          this.getMeeting(this.meetingCode)
          break
        case 'enterpriseExhibition':
          this.getExhibition(this.meetingCode)
          break
        case 'userMeeting':
          this.getMeeting(this.meetingCode)
          break
        case 'userExhibiton':
          this.getExhibition(this.meetingCode)
          break
      }
    },

    handleEnterpriseCodeFunc() {
      let query = ''
      if (this.type == 'enterpriseMeeting') {
        query = { meetingCode: this.meetingCode, meetingType: 'HOLD_MEETING', enterpriseCode: this.enterpriseCode }
      } else {
        query = { meetingCode: this.meetingCode, meetingType: 'EXHIBITION', enterpriseCode: this.enterpriseCode }
      }
      getEnterPriseQrcode(this.headers, query).then((res) => {
        // this.$set(this.pageInfo, 'qrCodeUrl', res.data.enterpriseQrcode)
        this.enterPriseqrcode = res.data.enterpriseQrcode
        // this.$set(this.pageInfo, 'qrCodeUrl', res.data.enterpriseQrcode)
        let allImg = [this.pageInfo.logo, this.pageInfo.shareCover, res.data.enterpriseQrcode]
        loadImageEnd(allImg, () => {
          console.log('图片加载完毕')
          this.complete = true
        })
      })
    },

    async getEnterpriseScene() {
      let query = ''
      if (this.type == 'enterpriseMeeting') {
        query = { meetingCode: this.meetingCode, meetingType: 'HOLD_MEETING', enterpriseCode: this.enterpriseCode }
      } else if (this.type == 'enterpriseExhibition') {
        query = { meetingCode: this.meetingCode, meetingType: 'EXHIBITION', enterpriseCode: this.enterpriseCode }
      } else {
        return false
      }
      let { data } = await handleEnterpriseCodeByScene(this.headers, query)
      console.log(data)
      if (data) {
        this.enterPriseqrcode = data.meetingEnterpriseQrcode
        console.log(this.pageInfo)
        this.$set(this.pageInfo, 'qrCodeUrl', data.meetingEnterpriseQrcode)
        let allImg = [this.pageInfo.logo, this.pageInfo.shareCover, data.meetingEnterpriseQrcode]
        loadImageEnd(allImg, () => {
          console.log('图片加载完毕')
          this.complete = true
        })
      }
    },

    async getHomePage() {
      const { data } = await getEnterpriseHomePage(this.headers, this.enterpriseCode)
      this.pageInfo = data
      console.log(this.pageInfo)
      this.enterpriseLogo = data.logo
      this.enterpriseName = data.enterpriseName
      this.introduction = data.introduction
    },

    getMeeting(code) {
      getMeetingPoster(this.headers, code).then(async (res) => {
        this.pageInfo = res.data
        this.pageInfo.shareCover = res.data.coverUrl
        this.pageInfo.enterpriseLogo = this.enterpriseLogo
        this.pageInfo.enterpriseName = this.enterpriseName
        this.pageInfo.introduction = this.introduction
        await this.getEnterpriseScene()

        if (this.type == 'userMeeting') {
          let allImg = [this.pageInfo.logo, this.pageInfo.coverUrl, this.pageInfo.qrCodeUrl]
          // this.getExhibition(this.meetingCode)
          loadImageEnd(allImg, () => {
            console.log('图片加载完毕')
            this.complete = true
          })
        }

        // console.log(this.pageInfo)
      })
    },

    async getExhibition(code) {
      let { data } = await exhibitionPoster(this.headers, code)
      this.pageInfo = data
      this.pageInfo.shareCover = data.coverUrl
      this.pageInfo.enterpriseLogo = this.enterpriseLogo
      this.pageInfo.enterpriseName = this.enterpriseName
      this.pageInfo.introduction = this.introduction
      await this.getEnterpriseScene()
      if (this.type == 'userExhibiton') {
        let allImg = [this.pageInfo.logo, this.pageInfo.coverUrl, this.pageInfo.qrCodeUrl]
        loadImageEnd(allImg, () => {
          console.log('图片加载完毕')
          this.complete = true
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.poster {
  background: #f5f5f5;
  .enterPrise {
    background: #fff;
    width: 654px;
    height: 1140px;
    .image_2 {
      width: 88px;
      height: 88px;
      margin: 24px 0 0 24px;
    }

    .image_3 {
      width: 606px;
      height: 485px;
      margin: 28px 0 0 24px;
    }

    .text-group_4 {
      width: 606px;
      // height: 127px;
      margin: 24px 0 0 24px;
    }

    .group_6 {
      background-color: rgba(224, 224, 224, 1);
      width: 606px;
      height: 1px;
      margin: 25px 0 0 24px;
    }

    .text_3 {
      width: 100%;
      overflow-wrap: break-word;
      color: rgba(38, 38, 38, 1);
      font-size: 32px;
      font-family:hanSans PingFang SC-Medium;
      font-weight: 500;
      text-align: left;
      white-space: break-spaces;
      line-height: 45px;
    }

    .text_4 {
      width: 100%;
      overflow-wrap: break-word;
      color: rgba(153, 153, 153, 1);
      font-size: 26px;
      font-family:hanSans PingFang SC-Regular;
      white-space: break-spaces;
      text-align: left;
      line-height: 36px;
      margin-top: 10px;
    }

    .image-text_3 {
      width: 573px;
      height: 90px;
      margin: 23px 0 0 24px;
    }

    .image_4 {
      width: 90px;
      height: 90px;
      border-radius: 50%;
    }
    .group_5 {
      background-color: rgba(255, 255, 255, 1);
      border-radius: 20px;
      width: 654px;
      height: 1140px;
      // margin: 48px 0 0 48px;
    }

    .text-group_5 {
      width: 463px;
      height: 70px;
      margin-top: 10px;
    }

    .text_5 {
      width: 56px;
      height: 39px;
      overflow-wrap: break-word;
      color: rgba(38, 38, 38, 1);
      font-size: 28px;
      font-family:hanSans PingFang SC-Medium;
      font-weight: 500;
      text-align: left;
      white-space: nowrap;
      line-height: 39px;
    }

    .text_6 {
      width: 463px;
      height: 31px;
      overflow-wrap: break-word;
      color: rgba(153, 153, 153, 1);
      font-size: 22px;
      font-family:hanSans PingFang SC-Regular;
      text-align: left;
      white-space: nowrap;
      line-height: 31px;
    }

    .group_7 {
      background-color: rgba(224, 224, 224, 1);
      width: 606px;
      height: 1px;
      margin: 25px 0 0 24px;
    }

    .image-text_4 {
      width: 154px;
      height: 176px;
      margin: 11px 0 12px 250px;
    }

    .image_5 {
      width: 196px;
      height: 196px;
    }

    .text-group_3 {
      width: 112px;
      height: 22px;
      overflow-wrap: break-word;
      color: rgba(158, 158, 158, 1);
      font-size: 16px;
      font-family:hanSans PingFang SC-Regular;
      font-weight: NaN;
      text-align: left;
      white-space: nowrap;
      line-height: 22px;
      margin-left: 21px;
    }
    .section_1 {
      width: 606px;
      height: 176px;
      margin: 13px 0 10px 24px;
      display: flex;
      justify-content: center;
    }

    .block_2 {
      background-color: rgba(221, 221, 221, 1);
      border-radius: 10px;
      width: 80px;
      height: 80px;
      margin-top: 48px;
      img {
        border-radius: 10px;
        width: 80px;
        height: 80px;
      }
    }

    .text_7 {
      width: 324px;
      height: 72px;
      overflow-wrap: break-word;
      color: rgba(38, 38, 38, 1);
      font-size: 26px;
      font-family:hanSans PingFang SC-Regular;
      font-weight: NaN;
      text-align: left;
      line-height: 36px;
      margin: 48px 0 0 20px;
    }

    .image-text_4 {
      width: 154px;
      height: 176px;
      margin-left: 28px;
    }

    .image_5 {
      width: 196px;
      height: 196px;
    }

    .text-group_3 {
      width: 112px;
      height: 22px;
      overflow-wrap: break-word;
      color: rgba(158, 158, 158, 1);
      font-size: 16px;
      font-family:hanSans PingFang SC-Regular;
      font-weight: NaN;
      text-align: left;
      white-space: nowrap;
      line-height: 22px;
      margin-left: 21px;
    }
  }
}

.meet {
  .block_1 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 20px;
    width: 654px;
    height: 1116px;
  }

  .image_2 {
    width: 88px;
    height: 88px;
    margin: 24px 0 0 24px;
  }

  .image_3 {
    width: 606px;
    height: 387px;
    margin: 28px 0 0 24px;
  }
  .box_8 {
    width: 525px;
    height: 36px;
    margin: 20px 0 0 24px;
  }
  .text_3 {
    width: 320px;
    height: 45px;
    overflow-wrap: break-word;
    color: rgba(38, 38, 38, 1);
    font-size: 32px;
    font-family:hanSans PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 45px;
    margin: 24px 0 0 24px;
  }

  .text_4 {
    width: 475px;
    height: 36px;
    overflow-wrap: break-word;
    color: rgba(153, 153, 153, 1);
    font-size: 26px;
    font-family:hanSans PingFang SC-Regular;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 36px;
  }

  .image-wrapper_1 {
    background-color: rgba(216, 216, 216, 0);
    height: 34px;
    margin-top: 1px;
    width: 34px;
  }

  .label_6 {
    width: 30px;
    height: 30px;
    // margin: 3px 0 0 3px;
    vertical-align: middle;
  }

  .box_9 {
    width: 606px;
    height: 60px;
    margin: 10px 0 0 24px;
  }

  .image-wrapper_2 {
    background-color: rgba(216, 216, 216, 0);
    height: 34px;
    margin-top: 1px;
    width: 34px;
  }

  .label_7 {
    width: 25px;
    height: 32px;
    margin-left: 2px;
  }

  .text_5 {
    width: 556px;
    height: 72px;
    word-break: break-all;
    color: rgba(153, 153, 153, 1);
    font-size: 26px;
    text-align: left;
    line-height: 36px;
  }

  .block_4 {
    background-color: rgba(224, 224, 224, 1);
    width: 606px;
    height: 1px;
    margin: 25px 0 0 24px;
  }

  .image-text_3 {
    width: 573px;
    height: 90px;
    margin: 23px 0 0 24px;
  }

  .image_4 {
    width: 90px;
    height: 90px;
    border-radius: 50%;
  }

  .text-group_3 {
    width: 463px;
    height: 70px;
  }

  .text_6 {
    width: 500px;
    word-break: break-all;
    color: rgba(38, 38, 38, 1);
    font-size: 26px;
    font-family:hanSans PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    line-height: 39px;
    display: inline-block;
  }

  .text_7 {
    width: 463px;
    height: 31px;
    overflow-wrap: break-word;
    color: rgba(153, 153, 153, 1);
    font-size: 22px;
    font-family:hanSans PingFang SC-Regular;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 31px;
  }

  .block_5 {
    background-color: rgba(224, 224, 224, 1);
    width: 606px;
    height: 1px;
    margin: 25px 0 0 24px;
  }

  .image-text_4 {
    width: 154px;
    height: 176px;
    margin: 4px 0 22px 250px;
  }

  .image_5 {
    width: 196px;
    height: 196px;
  }

  .text-group_2 {
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(158, 158, 158, 1);
    font-size: 20px;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 10px;
  }
}

.enterMeetOrExhibition {
  .section_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 20px;
    width: 654px;
    height: 1010px;
  }

  .image_6 {
    width: 606px;
    height: 387px;
    margin: 24px 0 0 24px;
  }

  .image_3 {
    width: 200px;
    height: 200px;
    margin: -80px 0 0 227px;
    border-radius: 50%;
  }

  .text-group_3 {
    width: 526px;
    height: 75px;
    margin: 30px 0 0 64px;
  }

  .text_3 {
    width: 308px;
    height: 39px;
    overflow-wrap: break-word;
    color: rgba(38, 38, 38, 1);
    font-size: 28px;
    font-family:hanSans PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 39px;
    margin-left: 109px;
  }

  .text_4 {
    width: 526px;
    height: 31px;
    overflow-wrap: break-word;
    color: rgba(153, 153, 153, 1);
    font-size: 22px;
    font-family:hanSans PingFang SC-Regular;
    text-align: center;
    white-space: nowrap;
    line-height: 31px;
    margin-top: 5px;
  }

  .group_4 {
    width: 606px;
    height: 82px;
    margin: 30px 0 0 21px;
  }

  .box_6 {
    width: 34px;
    height: 80px;
    margin-top: 1px;
  }

  .image-wrapper_1 {
    background-color: rgba(216, 216, 216, 0);
    height: 34px;
    width: 34px;
  }

  .label_6 {
    width: 30px;
    height: 30px;
    margin: 3px 0 0 3px;
  }

  .image-wrapper_2 {
    background-color: rgba(216, 216, 216, 0);
    height: 34px;
    margin-top: 12px;
    width: 34px;
  }

  .label_7 {
    width: 25px;
    height: 32px;
    margin-left: 2px;
    // margin: 2px 0 0 5px;
  }

  .text-group_4 {
    width: 556px;
    height: 82px;
  }

  .text_5 {
    width: 475px;
    height: 36px;
    overflow-wrap: break-word;
    color: rgba(38, 38, 38, 1);
    font-size: 26px;
    font-family:hanSans PingFang SC-Regular;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 36px;
  }

  .text_6 {
    width: 556px;
    height: 36px;
    overflow-wrap: break-word;
    color: rgba(38, 38, 38, 1);
    font-size: 26px;
    font-family:hanSans PingFang SC-Regular;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 36px;
    margin-top: 10px;
  }

  .group_5 {
    width: 612px;
    height: 176px;
    margin: 40px 0 46px 21px;
  }

  .text_7 {
    width: 450px;
    height: 170px;
    overflow-wrap: break-word;
    color: rgba(158, 158, 158, 1);
    font-size: 24px;
    font-family:hanSans PingFang SC-Regular;
    font-weight: NaN;
    text-align: left;
    line-height: 34px;
  }

  .box_7 {
    width: 154px;
    height: 176px;
  }

  .image_4 {
    width: 154px;
    height: 154px;
  }

  .text_8 {
    width: 112px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(158, 158, 158, 1);
    font-size: 16px;
    font-family:hanSans PingFang SC-Regular;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 21px;
  }
}
</style>